<span>  {{date}} : {{detail}} : [{{params.data.logdetail}}]</span>